var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "work-select-form" },
    [
      _vm.categoryOptions.length
        ? _c("div", { staticClass: "field" }, [
            _c(
              "label",
              {
                staticClass: "field-label",
                attrs: { for: "contest-entry-category" },
              },
              [
                _vm._v(
                  " " + _vm._s(_setup.t("contestEntryDataForm.category")) + " "
                ),
                _c(
                  "span",
                  {
                    staticClass: "required-mark",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_vm._v("*")]
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "select-wrapper" },
              [
                _c(
                  "select",
                  {
                    staticClass: "field-input field-select",
                    attrs: { id: "contest-entry-category" },
                    domProps: { value: _vm.value.categoryId },
                    on: { change: _setup.onCategoryChange },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v(
                        _vm._s(
                          _setup.t("contestEntryDataForm.categoryPlaceholder")
                        )
                      ),
                    ]),
                    _vm._l(_vm.categoryOptions, function (option) {
                      return _c(
                        "option",
                        {
                          key: option.value,
                          domProps: { value: option.value },
                        },
                        [_vm._v(" " + _vm._s(option.label) + " ")]
                      )
                    }),
                  ],
                  2
                ),
                _c(_setup.IconChevronDown, { staticClass: "select-chevron" }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "submission-section" },
        [
          _c("h2", { staticClass: "submission-title" }, [
            _vm._v(_vm._s(_setup.t("contestEntryForm.step2.submissionWork"))),
          ]),
          _setup.hasSelectedNolaWork
            ? [
                _c(
                  "div",
                  { staticClass: "selected-work-card" },
                  [
                    _c(_setup.ImageView, {
                      staticClass: "selected-work-cover",
                      attrs: { src: _vm.value.novelImage },
                    }),
                    _c("p", { staticClass: "selected-work-title" }, [
                      _vm._v(_vm._s(_vm.value.novelTitle)),
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "clear-work-button",
                        attrs: {
                          type: "button",
                          "aria-label": _setup.t(
                            "contestEntryForm.step2.clearSelectedWork"
                          ),
                        },
                        on: { click: _setup.clearSelectedWork },
                      },
                      [
                        _c(_setup.IconClose, {
                          staticClass: "clear-work-icon",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "field-header" }, [
                    _c(
                      "label",
                      {
                        staticClass: "field-label",
                        attrs: { for: "contest-entry-work-title" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _setup.t("contestEntryForm.step2.workTitle.label")
                            ) +
                            " "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "required-mark",
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("*")]
                        ),
                      ]
                    ),
                    _c("span", { staticClass: "field-count" }, [
                      _vm._v(_vm._s(_vm.value.workTitle.length) + "/100"),
                    ]),
                  ]),
                  _c("input", {
                    staticClass: "field-input",
                    attrs: {
                      id: "contest-entry-work-title",
                      type: "text",
                      maxlength: "100",
                    },
                    domProps: { value: _vm.value.workTitle },
                    on: { input: _setup.onWorkTitleInput },
                  }),
                ]),
                _c("div", { staticClass: "field synopsis-field" }, [
                  _c("div", { staticClass: "field-header" }, [
                    _c(
                      "label",
                      {
                        staticClass: "field-label",
                        attrs: { for: "contest-entry-synopsis" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _setup.t("contestEntryForm.step2.synopsis.label")
                            ) +
                            " "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "required-mark",
                            attrs: { "aria-hidden": "true" },
                          },
                          [_vm._v("*")]
                        ),
                      ]
                    ),
                    _c("span", { staticClass: "field-count" }, [
                      _vm._v(_vm._s(_vm.value.synopsis.length) + "/1,000"),
                    ]),
                  ]),
                  _c("textarea", {
                    staticClass: "field-input field-textarea",
                    attrs: {
                      id: "contest-entry-synopsis",
                      maxlength: "1000",
                      rows: "5",
                      placeholder: _setup.t(
                        "contestEntryForm.step2.synopsis.placeholder"
                      ),
                    },
                    domProps: { value: _vm.value.synopsis },
                    on: { input: _setup.onSynopsisInput },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "field copy-synopsis-field" },
                  [
                    _c(_setup.ContestEntryCopySynopsisSelect, {
                      on: { select: _setup.onCopySynopsisSelect },
                    }),
                  ],
                  1
                ),
              ]
            : _c("div", { staticClass: "source-cards" }, [
                _c(
                  "button",
                  {
                    staticClass: "source-card",
                    class: { selected: _vm.value.workSource === "nola" },
                    attrs: {
                      type: "button",
                      disabled: _setup.isSourceSelectDisabled,
                    },
                    on: { click: _setup.onClickSelectFromNola },
                  },
                  [
                    _c(_setup.IconNoteBook, { staticClass: "source-icon" }),
                    _c("span", { staticClass: "source-label" }, [
                      _vm._v(
                        _vm._s(
                          _setup.t("contestEntryForm.step2.selectFromNola")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "source-card",
                    attrs: {
                      type: "button",
                      disabled: _setup.isSourceSelectDisabled,
                    },
                    on: { click: _setup.onClickImportFromLocal },
                  },
                  [
                    _c(_setup.IconUpload, { staticClass: "source-icon" }),
                    _c("span", { staticClass: "source-label" }, [
                      _vm._v(
                        _vm._s(
                          _setup.t("contestEntryForm.step2.importFromLocal")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
        ],
        2
      ),
      _vm.extraFieldItems.length
        ? _c(
            "div",
            { staticClass: "extra-fields" },
            _vm._l(_vm.extraFieldItems, function (field, index) {
              return _c(
                "div",
                { key: `${field.key}-${index}`, staticClass: "field" },
                [
                  _c("div", { staticClass: "field-header" }, [
                    _c(
                      "label",
                      {
                        staticClass: "field-label",
                        attrs: { for: `contest-entry-extra-${index}` },
                      },
                      [
                        _vm._v(" " + _vm._s(field.title) + " "),
                        field.required
                          ? _c(
                              "span",
                              {
                                staticClass: "required-mark",
                                attrs: { "aria-hidden": "true" },
                              },
                              [_vm._v("*")]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _setup.extraFieldMaxLength(field) !== undefined
                      ? _c("span", { staticClass: "field-count" }, [
                          _vm._v(
                            " " +
                              _vm._s(_setup.extraAnswer(field.key).length) +
                              "/" +
                              _vm._s(field.maxLength) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  field.description
                    ? _c("p", { staticClass: "field-description" }, [
                        _vm._v(_vm._s(field.description)),
                      ])
                    : _vm._e(),
                  _c("input", {
                    staticClass: "field-input",
                    attrs: {
                      id: `contest-entry-extra-${index}`,
                      type: "text",
                      maxlength: _setup.extraFieldMaxLength(field),
                    },
                    domProps: { value: _setup.extraAnswer(field.key) },
                    on: {
                      input: function ($event) {
                        return _setup.onExtraAnswerInput(field.key, $event)
                      },
                    },
                  }),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "button",
          {
            staticClass: "back-button",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _setup.emit("back")
              },
            },
          },
          [_vm._v(" " + _vm._s(_setup.t("contestEntryForm.step2.back")) + " ")]
        ),
        _c(
          "button",
          {
            staticClass: "next-button",
            attrs: { type: "button", disabled: !_vm.canProceed },
            on: {
              click: function ($event) {
                return _setup.emit("next")
              },
            },
          },
          [_vm._v(" " + _vm._s(_setup.t("contestEntryForm.step2.next")) + " ")]
        ),
      ]),
      _setup.isImporting
        ? _c(_setup.MaskedLoading, { staticClass: "import-loading" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }